export enum Types {
	CONSULTAR_CPF_CIN_RESPONSAVEL_REQUEST = '@rfb/integrador/CONSULTAR_CPF_CIN_RESPONSAVEL_REQUEST',
	CONSULTAR_CPF_CIN_RESPONSAVEL_SUCCESS = '@rfb/integrador/CONSULTAR_CPF_CIN_RESPONSAVEL_SUCCESS',
	CONSULTAR_CPF_CIN_RESPONSAVEL_FAILURE = '@rfb/integrador/CONSULTAR_CPF_CIN_RESPONSAVEL_FAILURE',
	CONSULTAR_CPF_CIN_RESPONSAVEL_CLEAR = '@rfb/integrador/CONSULTAR_CPF_CIN_RESPONSAVEL_CLEAR',
}

export interface ConsultarCpfCinResponsavelState {
	status: number;
	data: ConsultarCpfCinResponsavel | null;
	dataError: ConsultarCpfCinResponsavelDataError | null;
	cpfRequest: string | null;
	instanceRequest?: string;
}

export interface ConsultarCpfCinResponsavel {
	cpfId: string;
	nomeContribuinte: string;
	nomeSocial: string;
	codSitCad: string;
	indResExt: string;
	codPaisRes: string;
	nomePaisRes: string;
	nomeMae: string;
	dtNasc: string;
	codSexo: string;
	codNatOcup: string;
	codOcup: string;
	anoExercicio: string;
	tipoLogradouro: string;
	logradouro: string;
	nroLogradouro: string;
	complemento: string;
	bairro: string;
	codMunDomic: string;
	ufMunDomic: string;
	cep: string;
	telefone: string;
	email: string;
	anoObito: string;
	codMunNat: string;
	ufMunNat: string;
	codPaisNac: string;
	nomePaisNasc: string;
	codUA: string;
	indEstrangeiro: string;
	dtInscricao: string;
	dtUltAtualiz: string;
}

export interface ConsultarCpfCinResponsavelDataError {
	transacao: string;
	codigo: number;
	mensagem: string;
	mensagens: string[];
}
